/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { TruckMenuContentFragment } from './TruckMenuContentFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type MenuByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']
}>

export type MenuByIdQuery = {
  __typename: 'Query'
  menu: {
    __typename: 'Menu'
    id: number
    active: boolean
    catering: boolean
    hasPrices: boolean
    taxIncluded: boolean
    trucks: Array<{ __typename: 'Truck'; id: number }>
    items: Array<{
      __typename: 'Item'
      id: number
      name: string
      description: string | null
      image: { __typename: 'ItemImage'; medium: string; present: boolean }
      upsellType: { __typename: 'UpsellType'; id: number }
      price: { __typename: 'Money'; formatted: string; cents: number }
      tags: Array<{ __typename: 'ItemTag'; id: string; name: string }>
    }>
  }
}

export const MenuByIdQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MenuByIdQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TruckMenuContentFragment' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'trucks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    ...TruckMenuContentFragment.definitions
  ]
} as unknown as DocumentNode

/**
 * __useMenuByIdQuery__
 *
 * To run a query within a React component, call `useMenuByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMenuByIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MenuByIdQuery,
    MenuByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<MenuByIdQuery, MenuByIdQueryVariables>(
    MenuByIdQueryDocument,
    options
  )
}
export function useMenuByIdQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MenuByIdQuery,
    MenuByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<MenuByIdQuery, MenuByIdQueryVariables>(
    MenuByIdQueryDocument,
    options
  )
}
export type MenuByIdQueryHookResult = ReturnType<typeof useMenuByIdQuery>
export type MenuByIdQueryLazyQueryHookResult = ReturnType<
  typeof useMenuByIdQueryLazyQuery
>
export type MenuByIdQueryQueryResult = Apollo.QueryResult<
  MenuByIdQuery,
  MenuByIdQueryVariables
>
